import React from 'react';
import { connect } from 'react-redux';
import { withStyles } from '@mui/styles';
import { Switch, Route } from 'react-router-dom';
import { withRouter } from "react-router-dom";
import {compose} from 'recompose';

import Dashboard from '../dashboard';
import Scripts from '../scripts';
import Projects from '../projects';
import Cards from '../cards';
import Reports from '../reports';
import Schedule from '../schedule';
import Operators from '../operators';
import Visor from '../visor';
import Statisctics from '../statistics';
import Queues from '../queues';
import Users from '../users';
import Cabinets from '../cabinets';

import NotFound from './404';
import FetchBanner from './Elements/FetchStatus';
import { drawerWidth } from './Menu';

const style = (theme) => ({
    content: {
      flexGrow: 1,
      backgroundColor: 'var(--canvas)',
      padding: 0,
      position: 'absolute',
      top: 0,
      right: 0,
      bottom: 0,
      left: 0,
      overflow: 'hidden',
      [theme.breakpoints.down('md')]: {
        marginTop: 'var(--mbar-h)',
      },
      [theme.breakpoints.up('md')]: {
        left: drawerWidth,
      }
    }
  });


const Main = ({classes}) =>(
    <main className={classes.content}>
      <FetchBanner />
      <Switch>
          <Route exact path='/' component={Dashboard} />
          <Route exact path='/schedule' component={Schedule.list} />
          <Route exact path='/schedule/create' component={Schedule.create} />
          <Route exact path='/schedule/:date/show' component={Schedule.show} />
          <Route exact path='/reports' component={Reports.list} />
          <Route exact path='/reports/:id' component={Reports.show} />
          <Route exact path='/reports/:id/:call' component={Reports.show} />
          <Route exact path='/cards/:id' component={Cards.edit} />
          <Route exact path='/operators' component={Operators.list} />
          <Route exact path='/operators/:id/show' component={Operators.show} />
          <Route exact path='/operators/:id/edit' component={Operators.edit} />
          <Route exact path='/operators/reports' component={Operators.reports} />
          <Route exact path='/operators/reports/:id/show' component={Operators.reports} />
          <Route exact path='/operators/reports/:id/edit' component={Operators.reports} />
          <Route path={['/visor/:id', '/visor']} component={Visor.list} />
          <Route exact path='/statistics' component={Statisctics.list} />
          <Route exact path='/scripts' component={Scripts.list} />
          <Route exact path='/scripts/:id' component={Scripts.edit} />
          <Route exact path='/projects' component={Projects.list} />
          <Route exact path='/projects/:id' component={Projects.edit} />
          <Route exact path='/queues' component={Queues.list} />
          <Route exact path='/queues/:id/show' component={Queues.list} />
          <Route exact path='/users' component={Users.list} />
          <Route exact path='/users/:id/show' component={Users.list} />
          <Route exact path='/users/:id/edit' component={Users.list} />
          <Route exact path='/users/create' component={Users.list} />
          <Route exact path='/cabinets' component={Cabinets.list} />
          <Route exact path='/cabinets/:id' component={Cabinets.list} />
          <Route path="*" component={NotFound} />
      </Switch>
    </main>
);

export default compose(
    withStyles(style),
    connect(),
    withRouter,
)(Main);
